import { ReactNode } from 'react';

import { ChartGraphic } from '../ChartGraphic';
import { ResponsiveChartGraphic } from './ResponsiveChartGraphic';

import styles from './ChartBackground.module.css';

export const ChartBackground = ({ children }: { children: ReactNode }) => {
  return (
    <div className={styles.root}>
      <ChartGraphic className={styles.chart} />
      <ResponsiveChartGraphic />
      {children}
    </div>
  );
};
